import Swiper from "swiper";
import { Navigation, Scrollbar } from "swiper/modules";

import "swiper/css";

document.addEventListener("DOMContentLoaded", () => {
    new Swiper(".swiper", {
        modules: [Navigation, Scrollbar],
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        scrollbar: { el: ".swiper-scrollbar", draggable: true },
        slidesPerView: "auto",
        breakpoints: {
            230: { slidesPerView: 1.2 },
            350: { slidesPerView: 1.3 },
            430: { slidesPerView: 1.8 },
            560: { slidesPerView: 2.3 },
            992: { slidesPerView: 3 },
            1000: { slidesPerView: 3.5 },
            1200: { slidesPerView: 4 },
        },
    });

    function calc_price() {
        let base_prices = {
            regular: 3500,
            general: 6500,
            repair: 8500,
        };

        let room_count = parseInt($("#room_count").val());
        let clean_type = $("#clean_type").val();

        let price = base_prices[clean_type] + (room_count - 1) * 1500;
        $("#total_price").text(price.toLocaleString("ru-RU"));
    }

    $("#room_count, #clean_type").on("change", calc_price);
    calc_price();

    // $("#cleaning_form").on("submit", function (e) {
    //     e.preventDefault();
    //     alert(
    //         "Заявка отправлена!\nТелефон: " +
    //             $("#phone").val() +
    //             "\nСтоимость: " +
    //             $("#total_price").text() +
    //             " ₽"
    //     );
    // });

    $(function () {
        // Инициализация slick
        ["regular", "general", "postrepair"].forEach(function (item) {
            $(".cleaning-slider")
                .find(`.${item}`)
                .slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: false,
                    adaptiveHeight: true,
                    asNavFor: $(`.cleaning-slider-images .${item}`),
                });
            $(".cleaning-slider-images")
                .find(`.${item}`)
                .slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    fade: true,
                    adaptiveHeight: true,
                    asNavFor: $(`.cleaning-slider .${item}`),
                });
        });

        // Переключение типа уборки

        $(".types_btns")
            .find("button")
            .on("click", function () {
                $(".types_btns").find("button").removeClass("active");
                $(".types_btns").find("button").addClass("btn_new23_empty");
                $(this).addClass("active");
                $(this).removeClass("btn_new23_empty");
                let type = $(this).data("type");

                if (type === "postrepair") {
                    $(".description_slider_wr").find(".arrows").hide();
                } else {
                    $(".description_slider_wr").find(".arrows").show();
                }
                    $(".cleaning-slider")
                        .find(`.${type}`)
                        .show()
                        .siblings()
                        .hide();
                $(".cleaning-slider-images")
                    .children()
                    .hide();
                    $(".cleaning-slider-images")
                        .find(`.${type}`)
                        .show();
                $(".cleaning-slider").find(`.${type}`).slick("setPosition");
                $(".cleaning-slider-images")
                    .find(`.${type}`)
                    .slick("setPosition");
            });

        // Кнопка "еще X опций"
        $(".toggle-more")
            .each(function () {
                let list = $(this).siblings(".work-list");
                let hidden_count = list.find("li.d-none").length;
                $(this).text(`еще ${hidden_count} опций`);
            })
            .on("click", function () {
                let list = $(this).siblings(".work-list");
                let hidden = list.find("li.d-none");

                let visible_count = list.data("visible_count") || Infinity;

                if (hidden.length) {
                    hidden.removeClass("d-none");
                    $(this).text("Скрыть");
                } else {
                    list.find("li:gt(" + (visible_count - 1) + ")").addClass(
                        "d-none"
                    );
                    let hidden_count = list.find("li.d-none").length;
                    $(this).text(`еще ${hidden_count} опций`);
                }

                // Обновляем высоту слайдера
                let active_type = $(".types_btns").find(".active").data("type");
                $(".cleaning-slider")
                    .find(`.${active_type}`)
                    .slick("setPosition");
            });

        $(".toggle-description").on("click", function () {
            let list = $(this).siblings(".work-list");

            let li = list.find("li");
            let descr_show = list.find(".visible_description").length;
            li.each(function () {
                li.toggleClass("visible_description");
            });

            if (descr_show) {
                $(this).text(`Показать описание`);
            } else {
                $(this).text(`Скрыть`);
            }

            // Обновляем высоту слайдера
            let active_type = $(".types_btns").find(".active").data("type");
            $(".cleaning-slider").find(`.${active_type}`).slick("setPosition");
        });

        // Показ описания под выбранной услугой
        $(".work-item").on("click", function (e) {
            e.preventDefault();

            let desc = $(this).data("desc");
            let li = $(this).closest("li");
            let list = $(this).closest(".work-list");

            // Удаляем все предыдущие описания
            list.find(".service-desc").remove();
            list.find(".work-item").removeClass("active");

            // Активный элемент
            $(this).addClass("active");

            // Вставляем описание под текущий пункт
            li.append(`<div class="service-desc">${desc}</div>`);
            let active_type = $(".types_btns").find(".active").data("type");
            $(".cleaning-slider").find(`.${active_type}`).slick("setPosition");
        });

        // handle clicks inside slides
        $(".cleaning-slider-custom-prev").on("click", function () {
            let active_type = $(".types_btns").find(".active").data("type");
            $(".cleaning-slider").find(`.${active_type}`).slick("slickPrev");
        });

        $(".cleaning-slider-custom-next").on("click", function () {
            let active_type = $(".types_btns").find(".active").data("type");
            $(".cleaning-slider").find(`.${active_type}`).slick("slickNext");
        });

        // function goToSlideByAttribute(
        //     attribute,
        //     value,
        //     sliderSelector = ".your-slider"
        // ) {
        //     const $slider = $(sliderSelector);
        //     const $slides = $slider.find(".slick-slide");

        //     // Find the slide with matching attribute
        //     const $targetSlide = $slides.filter(
        //         "[" + attribute + '="' + value + '"]'
        //     );

        //     if ($targetSlide.length) {
        //         const index = $targetSlide.data("slick-index");

        //         if (index !== undefined) {
        //             $slider.slick("slickGoTo", parseInt(index));
        //             return true;
        //         }
        //     }

        //     console.warn("Slide not found with", attribute, "=", value);
        //     return false;
        // }
        // $(".slide-nav").on("click", function () {
        //     const targetSlide = $(this).data("target-slide");
        //     goToSlideByAttribute("data-slide-type", targetSlide);
        // });
    });
});
